export const allowOnlyNumbers = $event => {
  const keyCode = $event.keyCode ? $event.keyCode : $event.which;
  if (keyCode < 48 || keyCode > 57 || keyCode === 46) {
    // keyCode 46 === .
    $event.preventDefault();
  }
};
